module.exports = __webpack_public_path__ + "img/52.f10baf30.png";